import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

// Components
import AssistantTextWithAvatar from '../components/offers/offers-assistant/AssistantTextWithAvatar';
import SignedOffer from '../components/signed-offers/SignedOffer';
import FlowerContainer from '../components/intro/FlowerContainer';
import { Box, Heading, VStack } from '@wegroup/design-system';
import CampaignsSignedOfferBottomContainer from '../components/signed-offers/CampaignsSignedOfferBottomContainer';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/redux/reducers/rootReducer';
import ErrorPage from '../../../common/src/components/ErrorPage';
import { loadSelectionState } from '../store/redux/slices/selectionSlice';
import SignedOfferBottomContainer from '../components/signed-offers/SignedOfferBottomContainer';
import { getI18nLanguageCode } from '../../../../i18n';
import useSessionId from '../../../flows/src/hooks/useSessionId';
import { isSocialLoginUrl } from '../../../app/src/features/authentication/constants/SocialAuth';

const SignView: React.FC<React.PropsWithChildren<unknown>> = () => {
  const dispatch = useDispatch();
  const sessionId = useSessionId();

  const { t } = useTranslation();

  const selectedOffers = useSelector(
    (state: RootState) => state.offers.selectedOffers,
  );
  const selectedRiskObjects = useSelector(
    (state: RootState) => state.selection.selectedRiskObjects,
  );

  useEffect(() => {
    initial();
  }, []);

  const initial = () => {
    // Fixes an issue where page refresh would cause all session data to be lost
    dispatch(loadSelectionState(sessionId));
  };

  return (
    <Box overflowX="hidden" minH="100vh" backgroundColor="secondary.800">
      <StyledFlowerContainer maxWidth="118.2rem">
        <VStack spacing={12}>
          <AssistantTextWithAvatar
            title={t('Your offers are ready to be signed!')}
            description={t(
              'Thank you for providing your information and calculating your offers Below, you will find the offers that need to be signed Click the buttons below to sign each offer You can always sign them at a later date via the email(s) you have received from us',
            )}
          />
          {(selectedRiskObjects.length === 0 ||
            selectedRiskObjects.every(
              (riskObject) =>
                selectedOffers[riskObject]?.length === 0 ||
                !selectedOffers[riskObject],
            )) && <ErrorPage />}
          {selectedRiskObjects
            .filter((riskObject) => selectedOffers[riskObject]?.length > 0)
            .map((riskObject) => (
              <VStack
                width="100%"
                align="left"
                spacing={6}
                key={`offerSign_riskObject_${riskObject}`}
              >
                <Heading as="h1" fontSize="xl">
                  {getI18nLanguageCode().toLowerCase() === 'fr'
                    ? `${t('Offers')} ${t(riskObject).toLowerCase()}`
                    : `${t(riskObject)} ${t('Offers').toLowerCase()}`}
                </Heading>
                {selectedOffers[riskObject]?.map((quoteId) => (
                  <SignedOffer
                    key={quoteId}
                    quoteId={quoteId}
                    riskObject={riskObject}
                  />
                ))}
              </VStack>
            ))}
          {isSocialLoginUrl ? (
            <CampaignsSignedOfferBottomContainer />
          ) : (
            <SignedOfferBottomContainer />
          )}
        </VStack>
      </StyledFlowerContainer>
    </Box>
  );
};

const StyledFlowerContainer = styled(FlowerContainer)`
  min-height: 90vh;
  margin: 2rem auto;
  > div:last-child {
    border-radius: 10px;
  }
`;

export default SignView;
